import * as Yup from 'yup'
import dayjs from 'dayjs'

Yup.addMethod(Yup.string, 'validateExpirationDate', function (errorMessage) {
  return this.test(`test-expiration-date`, errorMessage, function (value) {
    const { path, createError } = this

    if (!value) {
      return createError({ path, message: errorMessage })
    }

    const cleanValue = value.replace(/undefined/g, '').replace(/--/g, '-')

    const date = dayjs(cleanValue, 'MM-YYYY', true)

    if (!date.isValid()) {
      return createError({ path, message: 'Date must be in MM-YYYY format' })
    }

    if (date.isBefore(dayjs(), 'month')) {
      return createError({ path, message: 'Expiration date cannot be in the past' })
    }

    return true
  })
})

export const BankInformationSchema = Yup.object().shape({
  routingNumber: Yup.string().required('Routing number is required'),
  accountNumber: Yup.string().required('Account number is required'),
  accountType: Yup.string().required('Account type is required'),
})
